import React, { useState, useEffect } from "react";
import NavBar from "../../../components/navbar/NavBar";
import MoonPayView from "../../moonpay/MoonPayView";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Form from "react-bootstrap/Form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import Tooltip from "@mui/material/Tooltip";
import SolanaPrice from "../../../components/websocket/SolanaPrice";
import * as buffer from "buffer";
import useLocalWallet from "../../../utils/hooks";
import { TokenSaleApp } from "./token_buy";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import "@solana/wallet-adapter-react-ui/styles.css";

window.buffer = buffer.Buffer;

const Purchase = () => {
  const {
    isOpen,
    walletAddress,
    balance,
    isConnected,
    connected,
    handleRightToggle,
    copyAccountToClipboard,
    setIsOpen,
  } = useLocalWallet();
  const wallet = useAnchorWallet();
  const { wallet: testWallet } = useWallet();
  const [error, setError] = useState("");
  const [buyAmount, setBuyAmount] = useState("");

  const tokenPrice = process.env.REACT_APP_TOKEN_PRICE;

  const handleBuySolAmountChange = (event) => {
    setBuyAmount(event.target.value);
    setError("");
  };

  return (
    <>
      <NavBar />

      <div className={`sidebar-sec ${isOpen === true ? "active" : ""}`}>
        <section id="content-wrapper">
          <h4 className="my-dash">Purchase SOL and $LAL Tokens</h4>
          <div className="user-dashboard">
            <div className="right-sidebar">
              <div className="right-sidebar-inner">
                <nav className="navbar navbar-expand-lg navbar-light">
                  <div className="right-toggle-menu-outer">
                    <div className="right-toggle-menu">
                      <div
                        className="right-toggle-menu-inner"
                        onClick={handleRightToggle}
                      >
                        <div className="wallet">
                          {connected && walletAddress ? (
                            <button className="btn btn-one">
                              {wallet?.publicKey.toString().substring(0, 4)}
                              ...
                              {wallet?.publicKey.toString().slice(-4)}
                            </button>
                          ) : (
                            <button className="btn btn-two">Connect</button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </nav>
                <div
                  className={`right-sidebar ${isOpen === true ? "active" : ""}`}
                >
                  <div className="sd-header">
                    <div className="sd-header-btn" onClick={handleRightToggle}>
                      <i className="fa fa-times"></i>
                    </div>
                  </div>
                  <div className="sd-body">
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <div className="connect-card">
                          <div className="card-body">
                            <div className="card-inner">
                              <div className="wallet-ui">
                                <div className="wallet-add">
                                  <h6
                                    className={`wallet-address ${
                                      connected && walletAddress
                                        ? "wallet-connected"
                                        : "wallet-disconnected"
                                    }`}
                                  >
                                    {connected && walletAddress
                                      ? "Wallet Address "
                                      : ""}
                                    {connected && walletAddress
                                      ? `${walletAddress.substring(
                                          0,
                                          4
                                        )}...${walletAddress.slice(-4)}`
                                      : "Wallet not connected"}
                                  </h6>
                                  {connected && walletAddress ? (
                                    <Tooltip title="Copy Wallet Address" arrow>
                                      <FontAwesomeIcon
                                        icon={faCopy}
                                        className="admin-lfc-deposit-copy"
                                        onClick={copyAccountToClipboard}
                                      />
                                    </Tooltip>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="admin-lfc-deposit-balance">
                                  {connected ? (
                                    <p>Balance: {balance} SOL</p>
                                  ) : (
                                    <p>Balance: 0 SOL</p>
                                  )}
                                </div>
                                <WalletMultiButton />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`sidebar-overlay ${
                    isOpen === true ? "active" : ""
                  }`}
                  onClick={handleRightToggle}
                ></div>
              </div>
            </div>
            <div className="user-dashboard-inner">
              <div className="user-dashboard-tab">
                <div className="container">
                  <div className="user-dashboard-tab-inner">
                    <Tabs
                      defaultActiveKey="buycontract"
                      id="uncontrolled-tab-example"
                      className=""
                    >
                      <Tab eventKey="buycontract" title="Buy Token">
                        <TokenSaleApp
                          wallet={wallet}
                          isOpen={isOpen}
                          setIsOpen={setIsOpen}
                          balance={balance}
                          walletAddress={walletAddress}
                        />
                      </Tab>

                      <Tab eventKey="buy" title="Buy Solana">
                        <div className="mb-3 solana-display">
                          <i className="fa fa-arrow-right arrow-price"></i>
                          <h6>Current Solana Price :</h6>
                          <SolanaPrice />
                        </div>
                        <div className="mb-3 solana-display">
                          <i className="fa fa-arrow-right arrow-price"></i>
                          <h6>Current $LAL Price : ${tokenPrice} USD</h6>
                        </div>
                        <div className="send-tab">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlInput1"
                          >
                            <Form.Label>
                              Amount in Dollar<span>*</span>
                            </Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Enter Dollar Amount"
                              value={buyAmount}
                              onChange={handleBuySolAmountChange}
                              required
                            />
                          </Form.Group>
                        </div>
                        <div className="swap-btn">
                          <MoonPayView
                            userInput={buyAmount}
                            wallet={connected}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            setBuyAmount={setBuyAmount}
                            walletAddress={walletAddress}
                            error={error}
                            setError={setError}
                          />
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Purchase;
